import { QueryKeysEnum } from '@/enums';
import { AlertConfigCategoryEntity } from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class QcAlertCategoryService extends BaseService<
  'qcAlertCategory',
  AlertConfigCategoryEntity
> {
  constructor() {
    super(QueryKeysEnum.QC_ALERT_CATEGORY);
  }

  /** Fetch every QC alert category (unpaginated). */
  getAll = (): Promise<AlertConfigCategoryEntity[]> => {
    return APIService.get(this.path);
  };
}

export const qcAlertCategoryService = new QcAlertCategoryService();
